import React from "react";
import Hero from "../../components/hero/hero.component";
import AIimage from "../../assets/ai.jpg";
import user1 from "../../assets/img/one.png";
import user2 from "../../assets/img/two.png";
import Shake from "react-reveal/Shake";
import Standout from "../../components/standout/standout.component";
import user3 from "../../assets/img/three.png";
import predictiveImg from "../../assets/predictive.svg";
import objectDetectionImg from "../../assets/object-detection.svg";
import llmAssistantImg from "../../assets/llm-assistant.svg";
import { FaBrain, FaCloud, FaNetworkWired, FaRobot } from "react-icons/fa";
import StatsSection from "../../components/cyber-security/StatSection";
import CTASection from "../../components/cta/Call-to-action";
import Footer from "../../components/footer/footer.component";

const AImachineLearning = () => {
  const features = [
    {
      id: 1,
      title: "Machine Learning",
      description:
        "Learn how to build, train, evaluate, and optimize machine learning models for real-world problems.",
      icon: FaBrain,
    },
    {
      id: 2,
      title: "Deep Learning",
      description:
        "Build intelligent systems using neural networks, TensorFlow, PyTorch, and modern deep learning techniques.",
      icon: FaNetworkWired,
    },
    {
      id: 3,
      title: "Generative AI",
      description:
        "Explore LLMs, prompt engineering, embeddings, and modern AI applications.",
      icon: FaRobot,
    },
    {
      id: 4,
      title: "AI Deployment",
      description:
        "Learn how to deploy machine learning models and turn AI solutions into practical applications.",
      icon: FaCloud,
    },
  ];
  const enrollMessage = encodeURIComponent(
    `Hello, I'm interested in your AI & Machine Learning Training Program at Cephas ICT Hub. 
   
    I'd like to know more about the course, including the duration, training schedule, fees, learning format(online or onsite), and how to register.`,
  );

  const contactMessage = encodeURIComponent(
    "Hello, I'm interested in your AI & Machine Learning Training Program at Cephas ICT Hub. I'd like to know more about the course.",
  );

  const projects = [
    {
      id: 1,
      level: "ADVANCED",
      title: "Predictive Analytics Engine",
      description:
        "Build a robust forecasting model using time-series data to predict market trends with high accuracy.",
      image: predictiveImg,
    },
    {
      id: 2,
      level: "INTERMEDIATE",
      title: "Real-Time Object Detection",
      description:
        "Develop a computer vision pipeline capable of identifying and tracking multiple objects in live video feeds.",
      image: objectDetectionImg,
    },
    {
      id: 3,
      level: "EXPERT",
      title: "Custom LLM Assistant",
      description:
        "Fine-tune a large language model to create a specialized coding assistant capable of complex reasoning.",
      image: llmAssistantImg,
    },
  ];

  return (
    <div>
      <Hero
        pretitle="AI & Machine Learning Training Program"
        title={
          <>
            Master AI &
            <br />
            <span className="text-[#030A49]">Machine Learning. </span>
            <br />
            Build Skills That Matter.
          </>
        }
        description={
          "A rigorous, practical curriculum designed to take you from foundational concepts to deploying real-world AI models. Learn the tools andtechniques driving the future."
        }
        price="₦500,000"
        duration="6 Months"
        primaryLink={{
          href: `https://wa.me/2348141335945?text=${enrollMessage}`,
          text: "Enroll Now",
        }}
        secondaryLink={{
          //   href: `https://wa.me/2348141335945?text=${contactMessage}`,
          href: "/curriculum/AI ENGINEERING.jpg (1).pdf",
          text: "Course curriculum",
        }}
        users={[user1, user2, user3]}
        imageSrc={AIimage}
        features={features}
      />

      <StatsSection />

      <section className="bg-white px-4 py-16 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-7xl">
          {/* Heading */}
          <div className="mx-auto mb-8 max-w-2xl text-center">
            <h2 className="text-2xl font-bold tracking-tight text-[#12105E] sm:text-3xl md:text-4xl">
              Build Real-World Portfolio Projects
            </h2>

            <p className="mt-3 text-xs leading-5 text-slate-900 sm:text-sm">
              Apply what you learn immediately. Graduate with a portfolio of
              complex, functional AI applications.
            </p>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {projects.map((project) => (
              <article
                key={project.id}
                className="group overflow-hidden p-4 rounded-xl bg-[#080d1d] shadow-sm transition duration-300 hover:-translate-y-1 hover:shadow-xl"
              >
                {/* Image */}
                <div className="relative h-48 overflow-hidden sm:h-32">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
                  />

                  {/* Image overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-[#080d1d]/50 to-transparent" />

                  {/* Level badge */}
                  <span className="absolute left-2 top-2 rounded-md bg-[#101a35]/90 px-2 py-1 text-[7px] font-semibold tracking-wide text-white backdrop-blur-sm">
                    {project.level}
                  </span>
                </div>

                {/* Content */}
                <div className="min-h-[107px] p-3">
                  <h3 className="text-base font-semibold leading-5 text-white sm:text-lg">
                    {project.title}
                  </h3>

                  <p className="mt-2 text-[10px] leading-4 text-gray-300 sm:text-[11px]">
                    {project.description}
                  </p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="mb-20 py-10 relative">
        <div className="container mx-auto px-8 md:px-0">
          <Shake>
            <p className="capitalize text-[#000D83] text-4xl font-medium text-center">
              what makes us <span className="text-[#EFA632]">stand out</span>
            </p>
          </Shake>
          <Standout />
        </div>
        <div className="bg-[#3EC4FF] opacity-[.08] -z-10 absolute inset-0"></div>
      </section>

      <div>
        <CTASection
          title="Start Your AI & Machine Learning Journey!"
          description="Build practical skills in machine learning, deep learning, and modern artificial intelligence through hands-on projects."
          buttonText="Enroll Now"
          buttonLink={`https://wa.me/2348141335945?text=${contactMessage}`}
        />
      </div>

      <Footer />
    </div>
  );
};

export default AImachineLearning;
